import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import Analytics from "../../../analytics";
import {getModuleCombinations} from "../core/subparts/cabinet/cabinetModuleSystem";
import {MODULE_CONTEXT_MENU_TYPES, MODULE_CONTEXT_MENU_DIRECTIONS, CABINET_WIZARD_BUTTONS} from "../core/constants";
import Cabinet from "../core/parts/cabinet";
import {
  setModuleContextMenuType,
  setModuleContextMenuDirection,
  setModuleContextMenuModule,
  setModuleContextMenuModulePart,
  setActiveNavigationFilter, setActiveNavigationFilterStepIndex
} from "../../../actions/navigationFunctions";

import {getCurrentLayout} from "../../appLayout";

class CabinetContextMenu extends Component {

  static propTypes = {
    updateCanvas: PropTypes.func,
    contextMenuOpen: PropTypes.object,
    hoveredLayer: PropTypes.object,
    handleContextMenuClick: PropTypes.func,
    contextMenuPosition: PropTypes.object,
    closeContextMenu: PropTypes.func,
  };

  state = {
    contextMenuButtons: [],
  };

  componentDidMount() {
    if (this.props.closeContextMenu) {
      document.addEventListener('click', this.contextMenuBlur)
    }
    const moduleSplitted = this.props.contextMenuOpen.module.split("_"); // example: "4_4"
    this.props.setModuleContextMenuModule(moduleSplitted[0]);
    this.props.setModuleContextMenuModulePart(moduleSplitted[1]);
  }

  contextMenuBlur = (e) => {
    if (!e.target.closest('.contextmenu-buttons')
      && !e.target.closest('.contextmenu-buttons__button')
      && !e.target.closest('.contextmenu-slice')
      && !e.target.closest('.canvas')) {
      this.props.closeContextMenu();
    }
  };

  componentWillUnmount() {
    if (this.props.closeContextMenu) {
      document.removeEventListener('click', this.contextMenuBlur)
    }
  }

  resetModule = () => {
    const layout = getCurrentLayout();
    const cabinetParent = layout.parts[Cabinet.id];
    if (this.props.contextMenuOpen.contextMenuPartId === "top_cabinet") {
      const moduleSplitted = this.props.contextMenuOpen.module.split("_");  // example: "4_4"
      const arrayNumber = +moduleSplitted[0] - 1;
      cabinetParent.topCabinet.moduleSystem[arrayNumber] = (arrayNumber === 0 || arrayNumber === 5)
        ? ["36_18_19"] // copy array since it might be overwritten
        : ["36_36_1"];
      cabinetParent.topCabinet.activeFeatureParts = cabinetParent.topCabinet.setActiveFeatureParts();
      this.props.updateCanvas();
    } else if (this.props.contextMenuOpen.contextMenuPartId === "bottom_cabinet") {
      const moduleSplitted = this.props.contextMenuOpen.module.split("_");  // example: "4_4"
      const arrayNumber = +moduleSplitted[0] - 1;
      cabinetParent.bottomCabinet.moduleSystem[arrayNumber] = ["36_36_1"];
      cabinetParent.bottomCabinet.activeFeatureParts = cabinetParent.bottomCabinet.setActiveFeatureParts();
      this.props.updateCanvas();
    }
    this.props.closeContextMenu();
  };

  setCabinetModule = (buttonId) => {
    const layout = getCurrentLayout();
    console.log("buttonId", buttonId);
    console.log("this.props.contextMenuOpen", this.props.contextMenuOpen);
    const moduleParts = buttonId.split("-"); // example: "12_36_4-12_36_57-12_36_58" // width-height-id
    const cabinetParent = layout.parts[Cabinet.id];
    let subPartName = "";
    if (this.props.contextMenuOpen.contextMenuPartId === "top_cabinet") {
      subPartName = "topCabinet";
    } else if (this.props.contextMenuOpen.contextMenuPartId === "bottom_cabinet") {
      subPartName = "bottomCabinet";
    }
    if (this.props.contextMenuOpen.contextMenuPartId === "top_cabinet"
      || this.props.contextMenuOpen.contextMenuPartId === "bottom_cabinet") {
      const moduleSplitted = this.props.contextMenuOpen.module.split("_");  // example: "4_4"
      cabinetParent[subPartName].inlayTypes.forEach(inlayTypeObj => {
        const existingMJoinedIndex = inlayTypeObj.moduleParts.findIndex(mJoined => {
          return mJoined === this.props.contextMenuOpen.module
        });
        if (existingMJoinedIndex > -1) { // it is not a default! push new spliced
          // inlayTypeObj.moduleParts.splice(existingMJoinedIndex, 1);
          moduleParts.forEach((modulePart) => {
            inlayTypeObj.moduleParts.push(moduleSplitted[0] + "_" + modulePart.split("_")[2]);
          });
        }
      });
      const moduleSystemPart = cabinetParent[subPartName].moduleSystem[+moduleSplitted[0] - 1];
      // 1) remove old
      const oldIndex = moduleSystemPart.findIndex(modulePart => {
        // example: "12_36_4-12_36_57-12_36_58" // width-height-id
        return modulePart.split("_")[2] === this.props.moduleContextMenuModulePart
      });
      moduleSystemPart.splice(oldIndex,1);
      // 2) add new ones
      moduleParts.forEach((modulePart) => {
        moduleSystemPart.push(modulePart);
      });
      cabinetParent[subPartName].activeFeatureParts = cabinetParent[subPartName].setActiveFeatureParts();
      this.props.updateCanvas();
      layout.updateLocalStorage();
    }

  };

  getSliceButtons = () => {
    const availableSplitButtons = getModuleCombinations(this.props.moduleContextMenuModulePart, this.props.moduleContextMenuDirection);
    return availableSplitButtons.map(buttonId => {
      return {
        text: "",
        buttonId,
        onClick: () => {
          this.setCabinetModule(buttonId);
          this.props.closeContextMenu();
        }
      }
    })
  };
  getResetButton = () => {
    return {
      text: "Reset Module",
      buttonId: "reset",
      onClick: this.resetModule
    }
  };
  getExitButton = () => {
    return {
      text: "Exit config",
      buttonId: "exit_config",
      onClick: () => this.props.setModuleContextMenuType(MODULE_CONTEXT_MENU_TYPES.Filters)
    }
  };
  openNavigationMenu = (e) => {
    const layout = getCurrentLayout();
    const cabinetParent = layout.parts[Cabinet.id];
    const subParts = cabinetParent.subParts();
    const subPart = subParts.find(menuItem => menuItem.part.partId === this.props.contextMenuOpen.contextMenuPartId);
    this.props.handleContextMenuClick(subPart); // top cabinet
    this.props.setActiveNavigationFilter(e.target.dataset.id);
    this.props.setActiveNavigationFilterStepIndex(e.target.dataset.index);
    this.props.closeContextMenu();
  };
  getCabinetConfigurationButtons = () => {
    const cabinetConfigurationButtons = CABINET_WIZARD_BUTTONS
      .filter(wizardButton => wizardButton.buttonId !== CABINET_WIZARD_BUTTONS[0].buttonId)
      .map((wizardButton) => {
        wizardButton.onClick = this.openNavigationMenu;
        return wizardButton
      });
    const availableModuleCombinations = getModuleCombinations(this.props.moduleContextMenuModulePart);
    if (availableModuleCombinations && availableModuleCombinations.length) {
      cabinetConfigurationButtons.push({
        text: "Door config",
        buttonId: "door_config",
        onClick: () => this.props.setModuleContextMenuType(MODULE_CONTEXT_MENU_TYPES.SliceButtons)
      })
    }
    return cabinetConfigurationButtons
  };
  getContextMenuButtons = () => {
    switch (this.props.moduleContextMenuType) {
      case MODULE_CONTEXT_MENU_TYPES.Filters:
        return (this.props.moduleContextMenuModulePart === "1") //remove reset button if there is nowhere to split
          ? this.getCabinetConfigurationButtons()
          : [...this.getCabinetConfigurationButtons(), this.getResetButton()];
      case MODULE_CONTEXT_MENU_TYPES.SliceButtons:
      default: {
        const sliceButtons = this.getSliceButtons();
        return sliceButtons.length
          ? [...sliceButtons, this.getExitButton(), this.getResetButton()]
          : [...this.getCabinetConfigurationButtons(), this.getResetButton()]
      }
    }
  };

  render() {

    let contextMenuStyles = (this.props.windowWidth > 991 && this.props.contextMenuPosition)
      ? this.props.contextMenuPosition
      : {};
    if (this.state.contextMenuButtons.length === 4) {
      contextMenuStyles = Object.assign({}, contextMenuStyles, {maxWidth:"210px"} )
    }
    const availableHorizontalAndVertical = ["1", "2", "3", "9", "10"]; // show buttons for available splits
    const firstSliceIsActve = (this.props.moduleContextMenuType === MODULE_CONTEXT_MENU_TYPES.SliceButtons)
      && availableHorizontalAndVertical.includes(this.props.moduleContextMenuModulePart);

    return (
      <div className="contextmenu" style={contextMenuStyles}>
        {firstSliceIsActve ? (
          <div className={"contextmenu-slice"}>
            {Object.keys(MODULE_CONTEXT_MENU_DIRECTIONS).map((direction) => (
              <button className={"ui-button2 ui-button2--white"
              + (this.props.moduleContextMenuDirection === direction ? " ui-button2--blue" : "")}
                      onClick={() => this.props.setModuleContextMenuDirection(direction)}
                      key={"direction"+direction}>
                {direction}
              </button>
            ))}
          </div>
        ) : null}
        <div className={"contextmenu-buttons"
        +(firstSliceIsActve ? " contextmenu-buttons--four-buttons-inline" : "")}>
          {this.getContextMenuButtons().map((contextButton, contextButtonIndex) => {
            return (
              <button key={contextButton.buttonId}
                      data-id={contextButton.buttonId}
                      data-index={contextButtonIndex}
                      onClick={(e) => {
                        Analytics.sendClickEvent('context-menu-' + contextButton.buttonId);
                        contextButton.onClick(e);
                      }}
                      className={"contextmenu-buttons__button contextmenu-buttons__button--"+contextButton.buttonId}>
                <span className="contextmenu-buttons__button-text">{contextButton.text}</span>
              </button>
            )
          })}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (store) => ({
  moduleContextMenuType: store.navigationState.moduleContextMenuType,
  moduleContextMenuDirection: store.navigationState.moduleContextMenuDirection,
  moduleContextMenuModulePart: store.navigationState.moduleContextMenuModulePart,
  windowWidth: store.serverState.windowWidth,
});

const mapDispatchToProps = {
  setModuleContextMenuType,
  setModuleContextMenuDirection,
  setModuleContextMenuModule,
  setModuleContextMenuModulePart,
  setActiveNavigationFilter,
  setActiveNavigationFilterStepIndex
};

export default connect(mapStateToProps, mapDispatchToProps)(CabinetContextMenu);
